/**
 * Convert chips block conditions to Formly hideExpression
 * Handles: chips block
 */

export interface ChipConditionProps {
	button?: string | { id?: string; name?: string; value?: string };
}

/**
 * Convert a chips condition to hideExpression
 * Returns expression that evaluates to TRUE when condition is MET
 * (Remember: hideExpression hides when TRUE, so we'll invert later)
 *
 * Chips works like radio buttons - checking if a specific chip is selected
 */
export function convertChipCondition(fieldKey: string, props: ChipConditionProps): string | undefined {
	const { button } = props;

	if (!button) {
		return undefined;
	}

	// Extract button value (can be string or object with id/name/value)
	let buttonValue: string;
	if (typeof button === 'string') {
		buttonValue = button;
	} else if (button.value) {
		buttonValue = button.value;
	} else if (button.name) {
		buttonValue = button.name;
	} else if (button.id) {
		buttonValue = button.id;
	} else {
		return undefined;
	}

	// Check if the field value equals the button value
	return `model['${fieldKey}'] === ${formatValue(buttonValue)}`;
}

/**
 * Format a value for use in JavaScript expression
 */
function formatValue(value: any): string {
	if (value === null || value === undefined) {
		return 'null';
	}

	if (typeof value === 'string') {
		// Escape single quotes
		const escaped = value.replace(/'/g, "\\'");
		return `'${escaped}'`;
	}

	if (typeof value === 'number') {
		return String(value);
	}

	if (typeof value === 'boolean') {
		return String(value);
	}

	// For objects or other types, convert to JSON string
	return JSON.stringify(value);
}
